module.exports = __webpack_public_path__ + "b60fe39d5f07107be72ef6a308e98878.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/brian.png
// module id = 647
// module chunks = 0